import { req } from 'react-reqq-lite';
import { toastSuccess } from 'react-geek-toast';
import {
  transformBillerOptions,
  transformRoleOptions,
  transformUser,
  transformSelectedUser,
} from './transformers';
import * as c from './constants';

export const getUserList = (params) => {
  req.get({
    key: c.ACL_BILLER_LIST,
    params,
    url: '/acl/v1/merchant_user_roles',
    transform: ({ data }) => ({
      data: transformUser(data),
    }),
    onSuccess: (res) => {
      const meta = res?.response?.meta;
      req.set(
        c.ACL_PAGER,
        {
          current_page: meta?.current_page,
          total_pages: meta?.last_page,
          total: meta?.total,
        } || {}
      );
    },
  });
};

export const getBillerOptions = () => {
  req.get({
    key: c.ACL_BILLER_OPTIONS,
    url: '/acl/v1/merchants',
    transform: ({ data }) => transformBillerOptions(data),
  });
};

export const getRoleOptions = () => {
  req.get({
    key: c.ACL_ROLE_LIST,
    url: '/acl/v1/roles',
    transform: ({ data }) => transformRoleOptions(data),
  });
};

export const createACLUser = (payload, onSuccess, onError) => {
  req.post({
    key: c.ACL_CREATE_USER,
    payload,
    url: '/acl/v1/merchant_user_roles',
    onSuccess: () => {
      toastSuccess('New User Created!');
      setTimeout(() => getUserList(), 1000);
      if (typeof onSuccess === 'function') onSuccess();
    },
    onError,
  });
};

export const updateUser = (id, payload, onSuccess, onError) => {
  req.put({
    key: c.ACL_UPDATE_USER,
    payload,
    url: `/acl/v1/merchant_user_roles/${id}`,
    onSuccess: () => {
      toastSuccess('User Updated!');
      setTimeout(() => getUserList(), 1000);
      if (typeof onSuccess === 'function') onSuccess();
    },
    onError,
  });
};

export const selectedUser = (id) => {
  req.get({
    key: c.ACL_SELECTED_USER,
    url: `/acl/v1/merchant_user_roles/${id}`,
    transform: ({ data }) => transformSelectedUser(data),
  });
};

export const deleteUser = (id, onSuccess) => {
  req.remove({
    key: c.ACL_DELETE_USER,
    url: `/acl/v1/merchant_user_roles/${id}`,
    onSuccess: () => {
      toastSuccess('User Deleted!');
      setTimeout(() => getUserList(), 1000);
      if (typeof onSuccess === 'function') onSuccess();
    },
  });
};

export const mfaToggleAllUsers = (status, onSuccess) => {
  req.put({
    key: c.ACL_MFA_TOGGLE_ALL_USERS,
    payload: {
      is_mfa_enabled: status,
    },
    url: '/acl/v1/merchant_user_roles/toggle_all/mfa',
    onSuccess: () => {
      toastSuccess(`${status ? 'Enabled' : 'Disabled'}`);
      setTimeout(() => getUserList(), 1000);
      if (typeof onSuccess === 'function') onSuccess();
    },
  });
};

export const changePassword = (payload, onSuccess, onError) => {
  req.post({
    key: c.ACL_CHANGE_PASSWORD,
    payload,
    url: '/auth/v1/change_password',
    onSuccess: () => {
      toastSuccess('Password changed successfully!');
      if (typeof onSuccess === 'function') onSuccess();
    },
    onError,
  });
};
